import styled from 'styled-components';

import { Button, message, Space, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AuditMenmber } from '../../../api/Team';

import { DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import React from 'react';
import { useState } from 'react';
import defaultAvatar from '../../../assets/images/icons/user-avater.png';
const TableContainer = styled.div`
  padding: 20px 10px;
  padding-top: 18px;
  padding-left: 24px;
  margin-bottom: 20px;
  overflow: hidden;
  ${(props) => props.isAdmin && `padding: 0;padding-top: 18px;;`}
`;
const TableTitle = styled.div`
  font-size: 18px;
  line-height: 18px;
  padding-bottom: 20px;
`;

const AuthorAvatar = styled.img`
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 16px;
  background-color: #fff;
  vertical-align: middle;
`;

const CommonTable = ({
  data,
  loading,
  title,
  pagination,
  header,
  operate,
  isUser,
  isCreator,
  fetchData,
  isAdmin,
}) => {
  const { t } = useTranslation();

  const [auditLoading, setAuditLoading] = useState(false);
  const [rejectLoading, setRejectloading] = useState(false);

  const Audit = async (type, id) => {
    if (type === 1) {
      setAuditLoading(true);
    } else {
      setRejectloading(true);
    }

    try {
      const { code, data, msg } = await AuditMenmber({
        audit_type: type,
        member_id: id,
      });
      if (code === '10000') {
        message.success('Operate success');
      } else {
        message.error(msg ? msg : data.msg ? data.msg : 'Operate failed');
      }
      fetchData();
    } catch (error) {
      // console.log(error);
    }
    setAuditLoading(false);
    setRejectloading(false);
  };

  const Columns = [
    {
      title: t('AuthorTable.title'),
      dataIndex: 'name',
      key: 'name',
      render: (_, { id, index, avatar }) => (
        <>
          <div
            style={{
              display: 'flex',
              juctifyContent: 'flex-start',
            }}
          >
            {/* {index === 0 ? (
              <RainkIMG src={First} />
            ) : index === 1 ? (
              <RainkIMG src={Second} />
            ) : index == 2 ? (
              <RainkIMG src={Three} />
            ) : (
              <span>{index}</span>
            )} */}
            <AuthorAvatar src={avatar ? avatar : defaultAvatar} />
            <Link
              to={`/whiteHats/detail/${id}`}
              style={{
                display: 'inline-block',
                color: '#fff',
                textAlign: 'left',
                fontSize: '16px',
                height: '30px',
                lineHeight: '30px',
                fontWeight: '500',
              }}
            >
              {_}
            </Link>
          </div>
        </>
      ),
      width: 250,
      // ellipsis: true,
      align: isAdmin ? 'left' : 'center',
      className: 'common-table-lv author-table-authors',
    },
    {
      title: t('AuthorTable.points'),
      dataIndex: 'total_points',
      key: 'total_points',
      render: (_, { total_points }) => (
        <div
          style={{
            fontSize: '16px',
            lineHeight: '16px',
            fontWeight: '500',
          }}
        >
          <span>{total_points}</span>
          <span
            style={{
              color: 'rgba(255, 255, 255, 0.4)',
            }}
          >{` ${t('TeamTable.integral')}`}</span>
        </div>
      ),
      // width: 75,
      align: 'center',
      className: 'common-table-lv',
    },
    {
      title: t('AuthorTable.reportNumber'),
      dataIndex: 'reports_count',
      key: 'reports_count',
      // width: 120,
      render: (_, { reports_count }) => (
        <div
          style={{
            fontSize: '16px',
            lineHeight: '16px',
            fontWeight: '500',
          }}
        >
          <span>{reports_count}</span>
          <span
            style={{
              color: 'rgba(255, 255, 255, 0.4)',
            }}
          >{` ${t('report')}`}</span>
        </div>
      ),
      align: 'center',
      className: 'common-table-lv',
    },
    {
      title: t('AuthorTable.registrationtime'),
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center',
      render: (_) => (
        <span
          style={{
            fontSize: '16px',
            lineHeight: '16px',
            fontWeight: '500',
            color: 'rgba(255, 255, 255, 0.4)',
          }}
        >
          {moment.unix(_).format('YYYY-MM-DD')}
        </span>
      ),
      className: 'common-table-cell-date',
    },
  ];

  const _userColumns = [
    {
      title: t('AuthorTable.status'),
      dataIndex: 'team_join_status',
      key: 'team_join_status',
      render: (_, { team_join_status }) => (
        <div>
          {team_join_status === 1 ? (
            <span
              style={{
                color: '#F33C3C',
              }}
            >
              {t('AuthorTable.status_.Already applied')}
            </span>
          ) : (
            <span
              style={{
                color: '#00EEC2',
              }}
            >
              {t('AuthorTable.status_.Joined')}
            </span>
          )}
        </div>
      ),
      width: 70,
      align: 'center',
      className: 'common-table-author',
    },
    {
      title: t('AuthorTable.operate'),
      dataIndex: 'stataus',
      key: 'stataus',
      render: (_, { team_join_status, id }) => {
        return team_join_status === 1 ? (
          <React.Fragment>
            <Button
              type={'text'}
              className="pass-button"
              loading={auditLoading}
              onClick={() => {
                Audit(1, id);
              }}
            >
              <CheckCircleOutlined /> {t('AuthorTable.operate_.Audit')}
            </Button>
            <Button
              type={'text'}
              className="delet-button"
              loading={rejectLoading}
              onClick={() => {
                Audit(0, id);
              }}
            >
              <DeleteOutlined /> {t('AuthorTable.operate_.Unpass')}
            </Button>
          </React.Fragment>
        ) : null;
      },
      width: 240,
      align: 'center',
      fixed: 'right',
      className: 'common-table-author',
    },
  ];

  const Column = isUser && isCreator ? [...Columns, ..._userColumns] : Columns;
  return (
    <TableContainer isAdmin={isAdmin}>
      {title ? <TableTitle>{title}</TableTitle> : null}
      <Table
        showHeader={isUser ? true : false}
        bordered={false}
        columns={Column}
        dataSource={data}
        pagination={(pagination, { hideOnSinglePage: true })}
        loading={loading}
        className="author-table"
        rowKey="id"
        scroll={{
          x: 'max-content',
        }}
      />
    </TableContainer>
  );
};

export default CommonTable;
